import con from '../../../connection';

const path = '/logout';

const logout = (url: string) => () => ({
  post: () => con.post(url + path, {}),
});

export default logout;
